import Common from '@/utils/common'
import encrypt_str from '@/utils/crypto'

// 创建下载 接口：zhangzhiwu
function getfile(data) {
  return Common.createRequest('report-api', 'EXPORT_JOB_QUERY', data, '查询导出列表')
}
// 创建下载 接口：zhangzhiwu
function Createfile(data) {
  return Common.createRequest('report-api', 'EXPORT_JOB_CREATE', data, '下载')
}
// 获取省市县
function getArea(data) {
  return Common.createRequest('dict-api', 'AREA_SELECT', data)
}
// 所属银行查询
function getBankList(data) {
  return Common.createRequest('dict-api', 'BANK_HEAD_QUERY', data)
}
// 查询申报明细相关费用
function declareFeeQuery(data) {
  return Common.createRequest('crossborder-order-api', 'declare_fee_query', data)
}
// 下载失败原因
function dataFileDownload(data) {
  return Common.createDownFileRequest('crossborder-order-api', 'DATA_DOWNLOAD', data)
}
// 上传文件
function declareDetailUpload(data) {
  return Common.createUploadRequest('crossborder-order-api', 'declare_detail_upload', data)
}
/* 申报单 */
function getDeclareOrder(data) {
  return Common.createRequest('crossborder-order-api', 'query_declaration_order', data)
}
// 查询商户开通产品
function getMerProductList(data) {
  return Common.createRequest('merchant-api', 'MER0018', data)
}
// 查询操作员对应商户号
function getMerNo(data) {
  return Common.createRequest('merchant-api', 'MER0040', data)
}
// 查询商户详情
function getMerchantDetail(data) {
  return Common.createRequest('crossborder-merchant-api', 'MER0002', data)
}
// 查询商户基本信息、结算信息
function getMerInfo(data) {
  return Common.createRequest('merchant-api', 'MER0002', data)
}
// 所属支行查询
function getBranchBankList(data) {
  return Common.createRequest('dict-api', 'BANK_BRANCH_QUERY', data)
}
// 获取产品
function getproductName(data) {
  return Common.createRequest('dict-api', 'PROD_QUERY', data)
}
// 获取字典信息
function getDict(data) {
  return Common.createRequest('dict-api', 'BUSINESS_DICT_SEARCH', data)
}
// 查询用户信息接口
function customerInfoSearch(data) {
  data.accountNo = encrypt_str(data.accountNo)
  return Common.createRequest('customer-api', 'customer_info_search_for_web', data)
}
function getPrecutBindList(data) {
  return Common.createRequest('aggregation-api', 'get_precut_bind_list', data)
}
function codeRoleSelect(data) {
  return Common.createRequest('user-api', 'CODE_ROLE_SELECT', data)
}
// 获取短信验证码
function getSmsCode(data) {
  return Common.createRequest('dict-api', 'SEND_SMS', data)
}

// 查询用户信息接口
function customerInfoSearchApi(data) {
  data.accountNo = encrypt_str(data.accountNo)
  return Common.createRequest('customer-api', 'customer_info_search_for_web', data)
}
export default {
  name: 'CommonApi',
  getfile,
  Createfile,
  getArea,
  getBankList,
  declareFeeQuery,
  dataFileDownload,
  declareDetailUpload,
  getDeclareOrder,
  getMerProductList,
  getMerNo,
  getMerchantDetail,
  getMerInfo,
  getBranchBankList,
  getproductName,
  getDict,
  customerInfoSearch,
  getPrecutBindList,
  codeRoleSelect,
  getSmsCode,
  customerInfoSearchApi
}
